module.exports = __webpack_public_path__ + "static/media/happygirlwithletter.e32ece31.png";